<template>
    <div class="pl-message-container"
         :class="classes">
        <pl-list direction="top">
            <pl-item v-for="(item,index) in messages" :key="item.id">
                <pl-message-item :message="item.message" :type="item.type" :time="item.time" :done="item.done" :click="item.click" @done="done(item,index)"/>
            </pl-item>
        </pl-list>
    </div>
</template>

<script>
    import PlMessageItem from "./pl-message-item";
    import PlList from "../list/pl-list";
    import PlItem from "../list/pl-item";

    export default {
        name: "pl-message-container",
        components: {PlItem, PlList, PlMessageItem,},
        props: {
            horizontal: {type: String, default: 'center'},
            vertical: {type: String, default: 'start'},
            messages: {type: Array, default: () => []},
            duration: {default: '30px'},
        },
        computed: {
            targetVertical() {
                return this.p_vertical || this.vertical
            },
            targetHorizontal() {
                return this.p_horizontal || this.horizontal
            },
            classes() {
                return [
                    `pl-message-container-${this.targetHorizontal}-${this.targetVertical}`
                ]
            },
        },
        data() {
            return {
                p_vertical: null,
                p_horizontal: null,
            }
        },
        methods: {
            done(item, index) {
                this.messages.splice(index, 1)
            },
            add(message) {
                this.messages.push(message)
            },
            remove(message) {
                const index = this.messages.indexOf(message)
                if (index > -1) this.messages.splice(index, 1)
            },
        }
    }
</script>

<style lang="scss">
    @include themeify {
        .pl-message-container {
            position: fixed;
            z-index: 9999;
            top: 30px;
            bottom: 30px;
            left: 30px;
            right: 30px;
            pointer-events: none;

            .pl-list {
                height: 100%;
                width: 100%;

                display: flex;
                justify-content: center;
                align-items: flex-start;
                flex-direction: column;
            }

            .pl-item {
                &:not(:last-child) {
                    margin-bottom: 12px;
                }
            }

            @each $horizontal in (start, center, end) {
                @each $vertical in (start, center, end) {
                    &.pl-message-container-#{$horizontal}-#{$vertical} {
                        .pl-list {
                            @if $horizontal == center {
                                align-items: center;
                            } @else {
                                align-items: flex-#{$horizontal};
                            }
                            @if $vertical == center {
                                justify-content: center;
                            } @else {
                                justify-content: flex-#{$vertical};
                            }
                        }
                    }
                }
            }

        }
        .pl-message-item {
            @include public-style;
            padding: 10px 16px;
            white-space: nowrap;
            border-radius: 4px;
            border: solid 1px;
            pointer-events: auto;
            cursor: pointer;
            min-width: 300px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;

            & > * {
                vertical-align: middle;
            }

            .pl-message-item-icon {
                margin-right: 9px;
            }

            .pl-message-item-close {
                opacity: 0;
            }

            &:hover {
                .pl-message-item-close {
                    opacity: 1;
                }
            }

            @include pl-colors(pl-message-item) {
                background-color: $pl-color-light;
                border-color: #ddd;
                color: $value;
                box-shadow: 0 2px 6px 0 #ddd;
            }

            &.pl-message-item-color-black {
                background-color: #333333;
                color: white;
                border-color: #000000;
                box-shadow: 0 2px 12px 0 #333333;
            }

            &.pl-message-item-color-white {
                background-color: white;
                color: $color-normal-content;
                border-color: #eee;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            }
        }
    }
</style>
